import EditableTextInput from './editable-text-input';

export { default as NumberInput } from './number-input';
export { default as TextInput } from './text-input';
export const TextInputTitle = EditableTextInput;
export { EditableTextInput };
